import React, { useState } from 'react';
import useAuthStore from '../store/authStore';
import { authApi } from '../api/auth';

export default function Settings() {
  const { user, roles } = useAuthStore();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (newPassword.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    try {
      await authApi.changePassword(currentPassword, newPassword);
      setMessage('Contraseña actualizada exitosamente');
      setCurrentPassword('');
      setNewPassword('');
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al cambiar contraseña');
    }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <h1 className="text-2xl font-bold text-gray-800">Configuración</h1>

      {/* User info */}
      <div className="bg-white rounded-xl border border-gray-200 p-6">
        <h2 className="font-semibold text-gray-800 mb-4">Información de la cuenta</h2>
        <div className="space-y-3 text-sm">
          <div className="flex justify-between py-2 border-b border-gray-100">
            <span className="text-gray-500">Usuario</span>
            <span className="font-medium text-gray-800">{user?.username}</span>
          </div>
          <div className="flex justify-between py-2 border-b border-gray-100">
            <span className="text-gray-500">Email</span>
            <span className="font-medium text-gray-800">{user?.email}</span>
          </div>
          <div className="flex justify-between py-2 border-b border-gray-100">
            <span className="text-gray-500">Nombre</span>
            <span className="font-medium text-gray-800">{user?.full_name || '—'}</span>
          </div>
          <div className="flex justify-between py-2">
            <span className="text-gray-500">Roles</span>
            <div className="flex gap-1">
              {roles.map((role) => (
                <span key={role} className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded text-xs font-medium">
                  {role}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Change password */}
      <div className="bg-white rounded-xl border border-gray-200 p-6">
        <h2 className="font-semibold text-gray-800 mb-4">Cambiar contraseña</h2>

        {message && <div className="mb-3 p-2 bg-green-50 text-green-700 rounded text-sm">{message}</div>}
        {error && <div className="mb-3 p-2 bg-red-50 text-red-700 rounded text-sm">{error}</div>}

        <form onSubmit={handleChangePassword} className="space-y-3">
          <input
            type="password"
            placeholder="Contraseña actual"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none"
            required
          />
          <input
            type="password"
            placeholder="Nueva contraseña (mínimo 6 caracteres)"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none"
            required
          />
          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700"
          >
            Actualizar contraseña
          </button>
        </form>
      </div>

      {/* App info */}
      <div className="bg-white rounded-xl border border-gray-200 p-6">
        <h2 className="font-semibold text-gray-800 mb-3">Acerca de</h2>
        <div className="text-sm text-gray-600 space-y-1">
          <p>IT Aduax — Agente de Estimación de Tiempos v4.0</p>
          <p>ADUAX S.A. de C.V.</p>
          <p className="text-gray-400">FastAPI + React + PostgreSQL + Docker</p>
        </div>
      </div>
    </div>
  );
}
